import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ColumnLayoutDirectivesModule } from '../column-layout-directives/column-layout-directives.module';
import { TwoColumnLayoutComponent } from './two-column-layout.component';
import { TitleIfOverflowDirective } from '../auto-title-directive/title-overflow.directive';
import { RegisterModule } from '../../register/register.module';

@NgModule({
   imports: [CommonModule, ColumnLayoutDirectivesModule,RegisterModule],
   declarations: [TwoColumnLayoutComponent],
   exports: [TwoColumnLayoutComponent, ColumnLayoutDirectivesModule,RegisterModule],
})
export class TwoColumnLayoutModule {}
